import { produce } from "immer";
import { mutate } from "swr";

import { HEADER_META_DATA_API } from "../../consts/index";
import { HeaderMetaData } from "../../types/index";
import { localStorage } from "../localStorage";

export function updateWishlistStateOptimistically() {
  mutate(
    HEADER_META_DATA_API,
    async (currentData?: { data: HeaderMetaData }) =>
      produce(currentData, (newState) => {
        if (newState?.data) {
          const wishlist = JSON.parse(localStorage.getItem("wishlist") || "{}");
          newState.data.wishlistItemCount = Object.keys(wishlist).filter(
            (key) => key != "null"
          ).length;
        }
      }),
    false
  );
}
